<h2 mat-dialog-title>{{ 'ECMR.confirmation.title' | translate }}</h2>
<section>
    <mat-dialog-content
        class="py-0 overflow-hidden d-flex justify-content-start flex-column gap-2">
        <h5 class="content">{{ data.text | translate }}</h5>
        @if (data.checkBoxText) {
            <mat-checkbox
                class="text-start"
                [checked]="dialogResult.isCheckboxTicked"
                (change)="toggleCreateCopy()">
                {{ data.checkBoxText | translate }}
            </mat-checkbox>
        }
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="button-box">
            <button
                mat-flat-button
                (click)="close(false)"
                color="warn">
                {{ 'ECMR.confirmation.cancel' | translate }}
            </button>
            <button
                mat-flat-button
                class="m-0"
                (click)="close(true)"
                color="primary">
                {{ 'ECMR.confirmation.accept' | translate }}
            </button>
        </div>
    </mat-dialog-actions>
</section>
